import { render, staticRenderFns } from "./OnCallCalendar.vue?vue&type=template&id=966cf1e6"
import script from "./OnCallCalendar.vue?vue&type=script&lang=js"
export * from "./OnCallCalendar.vue?vue&type=script&lang=js"
import style0 from "./OnCallCalendar.vue?vue&type=style&index=0&id=966cf1e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports